
import gsap from "gsap";

// ドキュメントの読み込みが完了してから setUpAccordion 関数を呼び出す
document.addEventListener("DOMContentLoaded", () => {
  setUpAccordion();
});

// js-details クラスを持つすべての要素に対して、クリック時の挙動を定義
const setUpAccordion = () => {
  let elements = document.querySelectorAll(".js-details");
  let openedClass = "is-opened";

  // 各アコーディオン要素に対して処理を行う
  elements.forEach(element => {
    let summary = element.querySelector(".js-summary");
    let content = element.querySelector(".js-content");

    // サマリーがクリックされたときの処理
    summary.addEventListener("click", event => {
      event.preventDefault();

      // アコーディオンが開いているかどうかを判定して、それに応じて処理を行う
      if (element.classList.contains(openedClass)) {
        // 開いている場合は閉じるアニメーションを実行
        element.classList.toggle(openedClass);
        closingAnim(content, element).restart();
      } else {
        // 閉じている場合は開くアニメーションを実行
        element.classList.toggle(openedClass);
        element.setAttribute("open", "true");
        openingAnim(content).restart();
      }
    });
  });
};

// GSAPの to メソッドを使用してアコーディオンを閉じるアニメーションを定義
const closingAnim = (element, accordionElement) => gsap.to(element, {
  height: 0,  // 要素の高さ
  opacity: 0,  // 不透明度
  duration: 0.3,
  ease: "power3.out",
  overwrite: true,
  onComplete() {
    accordionElement.removeAttribute("open");  // アニメーション完了時、open 属性を削除
  }
});

// アコーディオンを開くアニメーションを定義
const openingAnim = element => gsap.fromTo(element, {
  height: 0,
  opacity: 0
}, {
  height: "auto",
  opacity: 1,
  duration: 0.3,
  ease: "power3.out",
  overwrite: true
});
